import { ajaxSpinner } from '../util/ajaxSpinner';

export default {
  init() {
  },
  finalize() {

    const lang = $('html').attr('lang');


    /**
     * Filters
     */
    $('#filter-date-order').on('change', function() {
      const dateOrderVal = $(this).find(':selected').val();
      window.location = $(`#filter-date-order-a-${dateOrderVal}`).attr('href');
    });


    /**
     * Load more
     */
    $('#load-more').click(function () {
      $(this).hide();
      load_news();
    });

    function load_news() {

      /**
       * Category query
       */
      // var urlParams = new URLSearchParams(window.location.search);
      // var cat = urlParams.get('category');

      /**
       * Get current page.
       */
      var current_page = parseInt($('#load-more').data('page'));
      const spinner = new ajaxSpinner($('.events-items-container'));

      $.ajax({
        url: `/wp-json/events-api/v1/get?page=${current_page}`,
        data: {
          page: current_page,
          lang: lang == 'cy-GB' ? 'cy' : 'en',
          type: $('.events-listing').data('type'),
          date_order: $('.events-listing').data('date-order'),
        },
      })
        .done(function (res) {

          // Append posts to page.

          res.posts.forEach(function (post) {

            //  Bilingual bits.

            var date = (lang == 'cy-GB' ? 'Dyddiad' : 'Date');
            var time = (lang == 'cy-GB' ? 'Amser' : 'time');
            var location = (lang == 'cy-GB' ? 'Lleoliad' : 'Location');
            var read_more = (lang == 'cy-GB' ? 'Darllen mwy' : 'Read more');


            const post_permalink = post.permalink;

            var o = `
              <div class="event-wrapper d-block w-100">
                <div class="row">
                  <div class="col-12 col-lg-6 col-xl-5" data-aos="fade-up" data-aos-duration="400">
                    <div class="image-wrapper" style="background-image: url(${post.thumbnail})">
                      <div class="date-bar">
                        <div class="date">${post.date_day}</div>
                        <div class="month">${post.date_mon_short}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6" data-aos="fade-up" data-aos-duration="400" data-aos-delay="200">
                    <div class="events-item-container">
                      <div class="event-detail-wrapper">
                        <div class="details">
                          <span class="d-block title">${post.post_title}</span>
                          <ul class="detail-list">
                            <li class="detail-item">
                              <span class="icon-date pr-4"></span>
                              <span class="detail-title"> ${date}:</span>
                              <span class="detail-text"> ${post.date_mon_long} ${post.date_day}, ${post.date_year}</span>
                            </li>
                            <li class="detail-item">
                              <span class="icon-time pr-4"></span>
                              <span class="detail-title"> ${time}:</span>
                              <span class="detail-text"> ${post.availability[0][0].from} - ${post.availability[0][0].to}</span>
                            </li>
                            <li class="detail-item">
                              <span class="icon-venue pr-4"></span>
                              <span class="detail-title"> ${location}:</span>
                              <span class="detail-text">${post.acf.venue}</span>
                            </li>
                          </ul>
                          <div class="text-block">
                          <p>${post.post_content_truncated}</p>
                          </div>
                          <div><a href="${post_permalink}" class="read-more-cta underline-hover">${read_more}</a></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

                <hr class="event-sep">`;

            $('.events-items-container').append(o);

            if (current_page >= res.max_num_pages) {
              $('#load-more').remove();
            }
          })

          /*
           * Update page.
           */
          $('#load-more').data('page', current_page + 1).fadeIn();
          spinner.remove();
        })
      .error(function () {
        console.log('Error retrieving data, trying again.');
        load_news();
      })
    }

    load_news()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-events-listing.js